module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4chaP3/tc-custom/9781035843299.jpg?1724125983057",
      "alt": "This image is the cover for the book Puddlehoppers 2 : Cloud Jumpers and the Hair Eater"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Puddlehoppers 2 : Cloud Jumpers and the Hair Eater\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Imagine a cloud that doesn’t move, just hovering above you. Odd, right? Now, picture someone perched in that cloud, watching you from above. Even stranger! But what if these cloud-dwellers were plotting revenge? Their targets: the unsuspecting puddle hoppers, who live their lives peacefully in puddles below. The situation in the town takes a bizarre turn as people start waking up bald. Yes, completely hairless! In the midst of this chaos, Gideon and Jules find themselves embroiled in yet another adventure. And things only get more hectic when the mischievous twins arrive, stirring up their usual brand of trouble!")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Terry Endacott\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Terry Endacott gained an MA from the University of East Anglia. He worked for many years in education before leaving the profession to devote more time to writing, playing music, and travelling. His writing genres include imaginative fantasy for both adults and older children.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0